module.exports = __webpack_public_path__ + "static/media/Dr.-Rezwanur-Rahman.78ef5b76.png";